var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEvent48Filled = function SvgIconEvent48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.59 15.84c-.5-2.41-2.64-4.23-5.19-4.23h-1.2V9.97h-3.4v1.64h-9.6V9.97h-3.4v1.64h-1.2a5.31 5.31 0 0 0-5.3 5.3v15.46c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V16.91c0-.37-.04-.72-.11-1.07ZM33.4 34.27H14.6a1.9 1.9 0 0 1-1.9-1.9V21.91h22.6v10.46a1.9 1.9 0 0 1-1.9 1.9Z",
    fill: "current"
  })));
};
export default SvgIconEvent48Filled;